import React from "react";
import { useNavigate } from 'react-router-dom';
import "./Stone.css";
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const Stone = () => {
   const navigate = useNavigate();

  const goToQuoteForm = () => {
    // Navigate to homepage with state
    navigate("/", { state: { scrollToForm: true } });
  };

  return (
    <div className="stone-page">
      <Header />
      {/* Hero Section */}
      <section className="stone-hero">
        <h1>Premium Stone Services</h1>
        <p>
          Beautiful, long-lasting stone patios, walkways, walls and more to elevate your outdoor spaces.
        </p>
      </section>

      {/* Services Highlights */}
      <section className="stone-services">
        <div className="stone-card-grid">
          {[
            { title: "Stone Patios", description: "Elegant outdoor patios perfect for entertaining." },
            { title: "Walkways", description: "Natural stone paths that complement your garden." },
            { title: "Retaining Walls", description: "Built strong to support and look stunning." },
            { title: "Fire Pits & Features", description: "Custom fire elements for cozy evenings." },
          ].map((item, i) => (
            <div className="stone-card" key={i}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Image Grid */}
      <section className="stone-gallery">
        {["stone.jpg", "stone2.jpg", "stone3.jpg"].map((img, i) => (
          <img
            key={i}
            src={`/images/${img}`}
            alt={`Stone project ${i + 1}`}
          />
        ))}
      </section>

      {/* CTA Section */}
      <section className="stone-cta">
        <p>
          Ready to take your outdoor space to the next level? Let’s build something beautiful.
        </p>


        <button
          onClick={goToQuoteForm}
          style={{
            backgroundColor: "#2E7D32",
            color: "white",
            border: "none",
            padding: "12px 30px",
            fontSize: "1rem",
            borderRadius: "8px",
            cursor: "pointer"
          }}>Request an Estimate <span className="cta-arrow">→</span>
        </button>

      </section>
      <Footer />
    </div>
  );
};

export default Stone;
